module.exports = __webpack_public_path__ + "img/ar19.d0f01323.jpg";